import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LOADING_STATE } from "types/general";
import { ASSET_DASHBOARD_SLICE_NAME, initialState } from "./constants";
import {
  fetchAssetDashboardSummary,
  fetchAssetDashboardCompetitiveSet,
} from "./controllers";

const assetDashboardSlice = createSlice({
  name: ASSET_DASHBOARD_SLICE_NAME,
  initialState,
  reducers: {
    resetAssetDashboardSummary: (state) => {
      state.summary = initialState.summary;
    },
    resetAssetDashboardCompetitiveSet: (state) => {
      state.competitiveSet = initialState.competitiveSet;
    },
    updateCompetitiveSetItemLocation: (
      state,
      {
        payload,
      }: PayloadAction<{
        propertyId: string;
        latitude: number;
        longitude: number;
      }>
    ) => {
      state.competitiveSet.data = state.competitiveSet.data.map((item) =>
        item.propertyId === payload.propertyId
          ? {
              ...item,
              latitude: payload.latitude,
              longitude: payload.longitude,
            }
          : item
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAssetDashboardSummary.pending, ({ summary }) => {
        summary.loadingState = LOADING_STATE.pending;
      })
      .addCase(fetchAssetDashboardSummary.rejected, ({ summary }) => {
        summary.loadingState = LOADING_STATE.rejected;
      })
      .addCase(
        fetchAssetDashboardSummary.fulfilled,
        ({ summary }, { payload }) => {
          summary.data = payload;
          summary.loadingState = LOADING_STATE.fulfilled;
        }
      )
      .addCase(
        fetchAssetDashboardCompetitiveSet.pending,
        ({ competitiveSet }) => {
          competitiveSet.loadingState = LOADING_STATE.pending;
        }
      )
      .addCase(
        fetchAssetDashboardCompetitiveSet.rejected,
        ({ competitiveSet }) => {
          competitiveSet.loadingState = LOADING_STATE.rejected;
        }
      )
      .addCase(
        fetchAssetDashboardCompetitiveSet.fulfilled,
        ({ competitiveSet }, { payload }) => {
          competitiveSet.data = payload;
          competitiveSet.loadingState = LOADING_STATE.fulfilled;
        }
      );
  },
});

export const {
  resetAssetDashboardSummary,
  resetAssetDashboardCompetitiveSet,
  updateCompetitiveSetItemLocation,
} = assetDashboardSlice.actions;

export default assetDashboardSlice;
